'use client';

import { Button } from '@/components/ui/button';
import { signInWithOAuth } from '@/utils/auth-helpers/client';
import { type Provider } from '@supabase/supabase-js';
import Google from '@/components/icons/Google';
import { useState } from 'react';
import { useToast } from '@/components/ui/Toasts/use-toast';

type OAuthProviders = {
  name: Provider;
  displayName: string;
  icon: JSX.Element;
};

export default function OauthSignIn() {
  const [isLoading, setIsLoading] = useState<Provider | null>(null);
  const { toast } = useToast();
  const oAuthProviders: OAuthProviders[] = [
    {
      name: 'google',
      displayName: 'Google',
      icon: <Google className="h-5 w-5" />
    }
  ];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const provider = String(formData.get('provider')).trim() as Provider;

    try {
      setIsLoading(provider);
      await signInWithOAuth(e);
    } catch (error) {
      toast({
        title: error instanceof Error ? error.message : 'Error signing in with provider',
        variant: 'destructive'
      });
    } finally {
      setIsLoading(null);
    }
  };

  return (
    <div className="mt-8 space-y-3">
      {oAuthProviders.map((provider) => (
        <form key={provider.name} className="pb-2" onSubmit={handleSubmit}>
          <input type="hidden" name="provider" value={provider.name} />
          <Button
            type="submit"
            className="w-full"
            disabled={isLoading !== null}
            variant={provider.name === 'google' ? 'outline' : 'default'}
          >
            <span className="mr-2">{provider.icon}</span>
            <span>
              {isLoading === provider.name
                ? `Signing in with ${provider.displayName}...`
                : `Continue with ${provider.displayName}`}
            </span>
          </Button>
        </form>
      ))}
    </div>
  );
}
